export default async function apiLoader(parameters){

    let results = {}
    let  params = parameters.params
    
  const response = await fetch(
    parameters.url,
    {
      mode: "cors",
      method: parameters.method,
      headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
      body: new URLSearchParams(params)      
    }
  );
  
  results.status = response.status
  const fetcher = response.body.getReader();
  let data = [];
  let receivedLength = 0;
  while (true) {
    const { value, done } = await fetcher.read();
  
    if (done) {
      break;
    }
  
    data.push(value);
    receivedLength += value.length;
  }
  let chunksAll = new Uint8Array(receivedLength);
  let position = 0;
  for (let chunk of data) {
    chunksAll.set(chunk, position);
    position += chunk.length;
  }
  let result = new TextDecoder("utf-8").decode(chunksAll);
  
  let finalData = JSON.parse(result);
  results.data = finalData;
  return results;
  }